import { render, staticRenderFns } from "./detailNews.vue?vue&type=template&id=1004adb3&"
import script from "./detailNews.vue?vue&type=script&lang=js&"
export * from "./detailNews.vue?vue&type=script&lang=js&"
import style0 from "./detailNews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports